<template>
  <div class="facetrange mb-5 mt-4" v-if="this.facet">

  <label class="facetlabel">{{$t('scifund.labels.'+facetname)}} <span v-if="inrange >0">({{inrange}})</span></label>

  <span v-if="facetname=='Technology_Readiness_Level__All' || facetname=='Technology_Readiness_Level__Prerequisite' || facetname=='Technology_Readiness_Level__Target'">
    &nbsp;<b-icon icon="exclamation-circle-fill" variant="secondary" v-b-popover.hover.top="'TRL information is extracted using NLP techniques and may be inaccurate. Please review call text for certainty.'"></b-icon>
  </span>

  <vue-slider
    ref="slider"
    v-model="value"
    :min="facet.adjustedStart"
    :max="facet.adjustedEnd"
    :interval="facet.gap"
    :tooltip="'always'"
    :enable-cross="false"
    :marks="marks"
    :lazy="true"
    tooltipPlacement="bottom"
    @change="facetChanged"
    class="mr-4 ml-3"
  ></vue-slider>
</div>
</template>

<script>


export default {
  name: 'facetrangeslider',
  props: [ 'facet', 'facetname' ],
  components: {
  },
  data: function () {
    return {
      value: [],
      marks: val => val,
      inrange: 0

    }
  },
  created: function () {
    if(this.facet) {
      if(this.activefilter && this.activefilter.valueLabel) {
        var split = this.activefilter.valueLabel.split(" TO ");
        var start = split[0].substring(1);
        var end = split[1].substring(0, split[0].length - 1);
        if( end > this.facet.adjustedEnd ) end = this.facet.adjustedEnd;
        this.value = [start, end];
      }

      if(!this.value || this.value.length==0) {
        this.value = [this.facet.adjustedStart, this.facet.adjustedEnd];
      }
    }

  },
  watch: {
    facet: function (newValue) {
      if( newValue ) {
        this.inrange = 0;
        for(var i in newValue.counts) {
          if(newValue.counts[i].active) {
            this.inrange += newValue.counts[i].count;
          }
        }

        if(!this.activefilter) {
          this.value = [this.facet.adjustedStart, this.facet.adjustedEnd];
        }
      }

    },
    activefilter: function (newValue) {
      if(newValue && newValue.valueLabel) {
        var split = newValue.valueLabel.split(" TO ");
        var start = split[0].substring(1);
        var end = split[1].substring(0, split[1].length - 1);
        if( end > this.facet.adjustedEnd ) end = this.facet.adjustedEnd;
        this.value = [start, end];
      }
    }
  },
  methods: {
    facetChanged: function (val) {
      var action = this.facet['sem_action']['sem_url_action'];
      action = decodeURIComponent(decodeURIComponent(action));
      action = action.replace('${start}', val[0]);
      // TODO: workaround
      var end = val[1];
      if( end == this.facet.adjustedEnd ) end = this.facet.end;
      action = action.replace('${end}', end);
      action = encodeURI(action);
      this.$router.push(action);

    }
  },
  computed: {
    activefilter () {
      if (this.$store.state.response &&
          this.$store.state.response.active_filters &&
          this.$store.state.response.active_filters.filters ) {
          var activefilters = this.$store.state.response.active_filters.filters;

          for( var i in activefilters ) {
            if( this.facetname == activefilters[i].componentName )
              return activefilters[i];
          }
      }
      return null;
    }
  }
}
</script>

<style scoped>
  .facetrange {
    margin-bottom: 10px;
  }

  .x {
    padding: 0px 20px;
  }
  .facetlabel {
    font-size: 14px;
    color: #888;
    font-weight: 700;
  }
</style>
